import { START_SOUND_URL } from '@mxa-argos/modules/forja/constants/forja.constants';

export function playStartSound(): void {
  new Audio(START_SOUND_URL).play().catch(() => undefined);
}
